import { NativeDateAdapter } from "@angular/material/core";
import moment from 'moment';
import { Injectable } from "@angular/core";

@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
     datewrapper:any;
   format(date: Date): string {
         this.datewrapper = moment(date).format('ddd, ll');
         return this.datewrapper;
   }
}
